import { FC, SetStateAction, Dispatch } from 'react'
import FieldWrapper from '@pages/Admin/CourseSettings/components/FieldWrapper/FieldWrapper'
import TextField from '@pages/Admin/CourseSettings/components/TextField/TextField'
import SecondaryButton from '@pages/Admin/CourseSettings/components/SecondaryButton/SecondaryButton'
import DatePicker from '@pages/Admin/CRM/components/base/DatePicker/DatePicker'
import dayjs from '@store/timetable/dayjs.config'
import { TeacherSalaryType } from '../../types'
import { TeacherStudentRateInput } from '../../utils/teacherSalary'
import cn from './index.module.css'

interface Props {
  salaryType: TeacherSalaryType
  effectiveFrom: string
  onEffectiveFromChange: (value: string) => void
  studentRates: TeacherStudentRateInput[]
  setStudentRates: Dispatch<SetStateAction<TeacherStudentRateInput[]>>
}

const TeacherSalaryScheduleFields: FC<Props> = ({
  salaryType,
  effectiveFrom,
  onEffectiveFromChange,
  studentRates,
  setStudentRates,
}) => (
  <>
    <FieldWrapper
      label="Применять ставку с даты"
      description="Дата включается в период новой ставки. Зарплата уже проведённых занятий сохраняется."
    >
      <DatePicker
        value={effectiveFrom ? dayjs(effectiveFrom) : null}
        onChange={(date) =>
          onEffectiveFromChange(date?.format('YYYY-MM-DD') ?? '')
        }
        format="DD.MM.YYYY"
        allowClear={false}
      />
    </FieldWrapper>
    {salaryType === 'per-lesson' && (
      <FieldWrapper
        label="Ставки по количеству присутствовавших"
        description="Сумма за целое занятие по отметкам журнала. Если точной ставки нет, применяется базовая зарплата."
      >
        <div className={cn.minAmountBlock}>
          {studentRates.map((rate, index) => (
            <div className={cn.rateRow} key={index}>
              <TextField
                label="Учеников"
                type="number"
                min={0}
                max={10000}
                value={rate.count}
                onChange={(count) =>
                  setStudentRates((rates) =>
                    rates.map((item, i) =>
                      i === index ? { ...item, count } : item
                    )
                  )
                }
              />
              <TextField
                label="Сумма за занятие"
                type="number"
                min={0}
                value={rate.salary}
                onChange={(salary) =>
                  setStudentRates((rates) =>
                    rates.map((item, i) =>
                      i === index ? { ...item, salary } : item
                    )
                  )
                }
              />
              <SecondaryButton
                onClick={() =>
                  setStudentRates((rates) =>
                    rates.filter((_, i) => i !== index)
                  )
                }
              >
                Удалить
              </SecondaryButton>
            </div>
          ))}
          <SecondaryButton
            onClick={() =>
              setStudentRates((rates) => [...rates, { count: '', salary: '' }])
            }
          >
            Добавить ставку
          </SecondaryButton>
        </div>
      </FieldWrapper>
    )}
  </>
)

export default TeacherSalaryScheduleFields
